<template>
     <modal
          class="new-modal-default create-configure-report-schedule"
          transition="nice-modal-fade create-configure"
          :name="modal_name"
          :delay="100"
          :width="400"
          height="auto"
          :adaptive="true" :scrollable="true"  :clickToClose="false"
     >
          <div class="v-modal-content" style="background-color: #ffffff !important;">
               <div class="v-modal-header-new">
                    <div></div>
                    <div>
                         <span class="v-modal-dialog-title-new v-modal-title fs-20" v-if="mode == 'create'">Add New Report Schedule </span>
                         <span class="v-modal-dialog-title-new v-modal-title fs-20" v-if="mode == 'edit'">Edit Report Schedule </span>
                    </div>
                    <div>
                         <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideModal"></span>
                    </div>
               </div>
               <div class="mb-3">
                    
                    <div>
                        <span class="fs-14 text-secondary ml-5" v-if="mode == 'create'">Schedule Info  </span>
                        <span class="fs-14 text-secondary ml-5" v-if="mode == 'edit'">Shift Info </span>
                    </div>
                </div>
               <div class="v-modal-body">
                    <div class="v-modal-layout px-4 border-blue" >
                         <div  class="d-flex align-items-center py-2 mt-2">
                                <span class=" fw-600 fs-15 mr-2" style="width: max-content;min-width: max-content; color:#130e0e">Shift Details</span>
                                <div class="inner-line-hr w-100"></div>
                            </div>
                         <div class="row">
                              <div class="col-lg-12 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <div class="w-100" style="position: relative;">
                                             <label class="inputLabel fs-14 fw-600 text-black">Schedule Name<span class="text-danger">*</span></label>
                                             <input class="inputFieldNew inputFieldNew-padding" v-validate="'required'" name="schedule_name" v-model="schedule_name" maxlength="30" type="text" autocomplete="off" placeholder="Enter Schedule Name" />
                                             <span class="inputBorder"></span>
                                        <div class="d-flex justify-content-between mt-2">
                                             <div class="invalid-feedback-form text-danger" style="margin-top: 0 !important;" v-show="errors.has('schedule_name')">{{errors.first('schedule_name')}}</div>
                                             <div class="text-right fs-14 w-100">{{30 - schedule_name.length}}/ 30</div>
                                        </div>
                                        </div>                                            
                                   </div>
                              </div>
                              <div class="col-lg-12 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0 email-tags">
                                        <span class="whiteSpace fs-14 fw-600 text-black">Email ID</span>
                                        <div class="w-100">
                                             <vue-tags-input v-model="email_id" v-validate="'email'" class="mt-2 w-100" name="tags" id='tags' placeholder="Add Email Ids" :tags="email_ids" @tags-changed="newTags => email_ids = newTags" />
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('tags') || errors.has('email_ids')">Please enter valid email id</span>
                                   </div>
                              </div>
                              <div class="col-lg-12 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <div class="w-100" style="position: relative;">
                                             <label class="inputLabel fs-14 fw-600 text-black">Description</label>
                                             <input class="inputFieldNew inputFieldNew-padding" name="Description" v-model="description" type="text" maxlength="250" autocomplete="off" placeholder="Enter Description" />
                                             <span class="inputBorder"></span>
                                             <div class="text-right fs-14">{{250 - description.length}}/ 250</div>
                                        </div>
                                        <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('Description')">{{errors.first('Description')}}</span> -->
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div class="mt-2 px-4 border-blue" >
                         <div  class="d-flex align-items-center py-2 mt-2">
                                <span class=" fw-600 fs-15 mr-2" style="width: max-content;min-width: max-content; color:#130e0e">Report schedule</span>
                                <div class="inner-line-hr w-100"></div>
                            </div>
                         <div class="row mt-5">
                              <div v-if="data_loader" class="checkoutLoader">
                                   <div class="LoaderPlacement">
                                        <div class="digi-table-loader">
                                             <div></div>
                                             <div></div>
                                             <div></div>
                                             <div></div>
                                        </div>
                                   </div>
                              </div>
                              <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                                   <span class="fs-14 fw-600 text-black">Report Schedule</span>
                              </div> -->
                              <div class="col-lg-12 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <span class="whiteSpace fs-14 fw-600 text-black pl-2">Schedule Time<span class="text-danger">*</span>
                                             <el-tooltip v-if="schedule_time_msg" class="item ml-1" effect="dark" :content="schedule_time_msg" placement="top">
                                                  <i class="icon icon-information text-black fs-16" style="color: #005dae;"></i>
                                             </el-tooltip>
                                        </span>
                                        <div class="">
                                             <multiselect
                                                  v-model="schedule_time"
                                                  class="diginew-multiselect diginew-multiselect-dropdown down-arrow mt-3"
                                                  id="ajaxpr"
                                                  :options="schedule_time_options"
                                                  :searchable="true"
                                                  :close-on-select="true"
                                                  v-validate="'required'"
                                                  name="schedule_time"
                                                  @select="scheduleSelected"
                                                  :show-labels="false"
                                                  :multiple="false"
                                                  :allow-empty="false"
                                                  :options-limit="3000"
                                                  :max-height="200"
                                                  :clear-on-select="false"
                                                  placeholder="Select Schedule Time"
                                                  :internal-search="true"
                                                  :show-no-results="true"
                                                  :hide-selected="false"
                                             >
                                             <template slot="tag">
                                                  <span class="custom__tag">
                                                  </span>
                                             </template>
                                             <template slot="noResult">
                                                  <div class="text-secondary text-center fw-600">No Results Found</div>
                                             </template>
                                             </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('schedule_time')">{{errors.first('schedule_time')}}</span>
                                   </div>
                              </div>
                              <div class="col-lg-12 col-md-12 col-sm-12" v-if="schedule_time == 'Shiftwise' || schedule_time == 'shiftwise'">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <span class="whiteSpace fs-14 fw-600 text-black pl-2">Shift<span class="text-danger">*</span></span>
                                        <div class="">
                                             <multiselect
                                                  v-model="shift_name"
                                                  class="diginew-multiselect diginew-multiselect-dropdown down-arrow mt-3"
                                                  :options="shift_name_options"
                                                  :loading="shift_loading"
                                                  :searchable="true"
                                                  :close-on-select="true"
                                                  v-validate="'required'"
                                                  name="shift_name"
                                                  :show-labels="false"
                                                  label="shift_name"
                                                  @search-change="searchShift"
                                                  @open="searchShift"
                                                  :multiple="false"
                                                  :allow-empty="false"
                                                  :options-limit="3000"
                                                  :max-height="200"
                                                  :clear-on-select="false"
                                                  placeholder="Select Shift"
                                                  :internal-search="true"
                                                  :show-no-results="true"
                                                  :hide-selected="false"
                                             >
                                             <template slot="afterList">
                                                  <div v-observe-visibility="reachedEndOfShiftList" ></div>
                                             </template>
                                             <template slot="noResult">
                                                  <div class="text-secondary text-center fw-600">No Results Found</div>
                                             </template>
                                             </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('shift_name')">{{errors.first('shift_name')}}</span>
                                   </div>
                              </div>
                              <!-- <div class="col-lg-6 col-md-12 col-sm-12" v-if="schedule_time == 'run once at' || schedule_time == 'Run Once At' || schedule_time == 'Run once at' || schedule_time == 'daily' || schedule_time == 'Daily'">
                                   <div class="form-group contactGroup">
                                        <span class="whiteSpace fs-14 fw-600 text-black pl-2">Date and Time<span class="text-danger">*</span></span>
                                        <div class="">
                                             <div class="d-flex report-date-time-picker report-date-time-picker-black-icons align-items-center mt-3">
                                                  <date-picker
                                                       v-model="report_date"
                                                       name="date"
                                                       class="ticketdate w-50 ticketDateHeight"
                                                       format="DD/MM/YYYY"
                                                       type="date"
                                                       lang="en"
                                                       @change="startDateChange($event)"
                                                       value-type="format"
                                                       :clearable="false"
                                                       :editable="false"
                                                       confirm
                                                       confirm-text="APPLY"
                                                  ></date-picker>
                                                  <date-picker
                                                       v-model="report_time"
                                                       format="hh:mm A"
                                                       name="time"
                                                       class="tickettime w-50"
                                                       type="time"
                                                       placeholder="Select Time"
                                                       value-type="format"
                                                       lang="en"
                                                       :clearable="false"
                                                       :editable="false"
                                                       :minute-step="1"
                                                       confirm
                                                       confirm-text="APPLY"
                                                  >
                                                  </date-picker>
                                             </div>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-if="is_report_date && is_report_time">Date and Time is required.</span>
                                        <span class="invalid-feedback-form text-danger" v-else-if="is_report_date">Date is required.</span>
                                        <span class="invalid-feedback-form text-danger" v-else-if="is_report_time">Time is required.</span>
                                   </div>
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12" v-if="schedule_time == 'Recurrence' || schedule_time == 'recurrence'">
                                   <div class="form-group contactGroup">
                                        <span class="whiteSpace fs-14 fw-600 text-black pl-2">Recurrence<span class="text-danger">*</span></span>
                                        <div class="">
                                             <multiselect
                                                  v-model="recurrence"
                                                  class="diginew-multiselect diginew-multiselect-dropdown mt-3"
                                                  id="ajaxpr"
                                                  :options="recurrence_options"
                                                  :searchable="true"
                                                  :close-on-select="true"
                                                  v-validate="'required'"
                                                  name="recurrence"
                                                  :show-labels="false"
                                                  :multiple="false"
                                                  :options-limit="3000"
                                                  :max-height="200"
                                                  :clear-on-select="false"
                                                  placeholder="Recurrence"
                                                  :internal-search="true"
                                                  :show-no-results="true"
                                                  :hide-selected="false"
                                             >
                                             <template slot="tag">
                                                  <span class="custom__tag">
                                                  </span>
                                             </template>
                                             <template slot="noResult">
                                                  <div class="text-secondary text-center fw-600">No Results Found</div>
                                             </template>
                                             </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('recurrence')">{{errors.first('recurrence')}}</span>
                                   </div>
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12" v-if="schedule_time == 'Recurrence' || schedule_time == 'recurrence'">
                                   <div class="form-group contactGroup">
                                        <span class="whiteSpace fs-14 fw-600 text-black pl-2">Start Date and Time<span class="text-danger">*</span></span>
                                        <div class="">
                                             <div class="d-flex report-date-time-picker report-date-time-picker-black-icons align-items-center mt-3">
                                                  <date-picker
                                                       v-model="start_date"
                                                       name="date"
                                                       class="ticketdate w-50 ticketDateHeight"
                                                       format="DD/MM/YYYY"
                                                       type="date"
                                                       lang="en"
                                                       value-type="format"
                                                       :clearable="false"
                                                       :editable="false"
                                                       @change="startDateChange($event)"
                                                       :not-before="new Date().toString()"
                                                       confirm
                                                       confirm-text="APPLY"
                                                       v-validate="'required'"
                                                  ></date-picker>
                                                  <date-picker
                                                       v-model="start_time"
                                                       format="hh:mm A"
                                                       name="time"
                                                       class="tickettime w-50"
                                                       type="time"
                                                       placeholder="Select Time"
                                                       value-type="format"
                                                       lang="en"
                                                       :clearable="false"
                                                       :editable="false"
                                                       :minute-step="1"
                                                       confirm
                                                       confirm-text="APPLY"
                                                       v-validate="'required'"
                                                  >
                                                  </date-picker>
                                             </div>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-if="is_start_date && is_start_time">Start Date and Start Time is required.</span>
                                        <span class="invalid-feedback-form text-danger" v-else-if="is_start_date">Start Date is required.</span>
                                        <span class="invalid-feedback-form text-danger" v-else-if="is_start_time">Start Time is required.</span>
                                   </div>
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12" v-if="schedule_time == 'Recurrence' || schedule_time == 'recurrence'">
                                   <div class="form-group contactGroup">
                                        <span class="whiteSpace fs-14 fw-600 text-black pl-2">End Date and Time<span class="text-danger">*</span></span>
                                        <div class="">
                                             <div class="d-flex report-date-time-picker report-date-time-picker-black-icons align-items-center mt-3">
                                                  <date-picker
                                                       v-model="end_date"
                                                       name="date"
                                                       class="ticketdate w-50 ticketDateHeight"
                                                       format="DD/MM/YYYY"
                                                       type="date"
                                                       lang="en"
                                                       :not-before="new Date(start_date_format) + 1"
                                                       value-type="format"
                                                       :clearable="false"
                                                       :editable="false"
                                                       confirm
                                                       confirm-text="APPLY"
                                                       v-validate="'required'"
                                                  ></date-picker>
                                                  <date-picker
                                                       v-model="end_time"
                                                       format="hh:mm A"
                                                       name="time"
                                                       class="tickettime w-50"
                                                       type="time"
                                                       placeholder="Select Time"
                                                       value-type="format"
                                                       lang="en"
                                                       :clearable="false"
                                                       :editable="false"
                                                       :not-before="start_time"
                                                       :minute-step="1"
                                                       confirm
                                                       confirm-text="APPLY"
                                                       v-validate="'required'"
                                                  >
                                                  </date-picker>
                                             </div>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-if="is_end_date && is_end_time">End Date and End Time is required.</span>
                                        <span class="invalid-feedback-form text-danger" v-else-if="is_end_date">End Date is required.</span>
                                        <span class="invalid-feedback-form text-danger" v-else-if="is_end_time">End Time is required.</span>
                                   </div>
                              </div> -->
                         </div>
                    </div>

                         <div class=" v-modal-dialog-actions-new">
                              <div class="d-flex justify-content-center align-items-center">
                                   <button class="btn btn-danger-new  fw-500 mr-3" @click="hideModal">Cancel</button>
                                   <button class="btn btn-green-new fw-500  ml-3" style="text-transform: capitalize !important;" :disabled="is_api_calling" @click="saveCreateData" :class="{'text-align-left': is_api_calling}">
                                        {{ is_api_calling ? 'Saving' : 'Save' }}
                                        <half-circle-spinner v-if='is_api_calling' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                                   </button>
                              </div>
                         </div>
               </div>
          </div>
          <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
          <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
     </modal>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue';
import VueTagsInput from "@johmun/vue-tags-input";
import moment from 'moment-timezone';
import facility_mgmt from '../../mixins/facility_mgmt';
import time_utils from '../../mixins/time_utils';
import { debounce } from 'lodash';
export default {
     mixins: [facility_mgmt, time_utils],
     components: {
          SweetModal,
          VueTagsInput,
          HalfCircleSpinner
     },
     props: ['modal_name', 'mode', 'report_schedule_id'],
     data(){
          return{
               data_loader: false,
               success_msg: '',
               warning_msg: '',
               schedule_name: '',
               email_id: '',
               email_ids: [],
               description:'',
               schedule_time: 'Daily',
               schedule_time_options: ['Daily','Shiftwise'],
               report_date: '',
               report_time: '',
               recurrence: '',
               shift_name: '',
               shift_name_options: [],
               shift_loading: false,
               recurrence_options: ['Every Monday','Every Tuesday','Every Wednesday','Every Thursday','Every Friday','Every Saturday','Every Sunday','Weekday','Weekend'],
               start_date: '',
               start_date_format: '',
               start_time: '',
               end_date: '',
               end_time: '',
               is_start_date: false,
               is_end_date: false,
               is_start_time: false,
               is_end_time: false,
               is_report_date: false,
               is_report_time: false,
               shift_search_key: '',
               shift_count: 0,
               isVisible: false,
               is_api_calling: false,
               scrollable: false,
               schedule_time_msg: "Daily Report would trigger at \n\n end of the day on daily basis"
               // schedule_time_msg: 'Shiftwise report will trigger at endtime of the selected shift'
          }
     },
     methods: {
          hideModal(){
               this.$emit('hide-add-new-schedule')
          },
          scheduleSelected(data) {
               if(data == 'Daily') {
                    this.schedule_time_msg = "Daily Report would trigger at \n\n end of the day on daily basis";
               } else if(data == 'Shiftwise') {
                    this.schedule_time_msg = "Shiftwise report will trigger at \n\n endtime of the selected shift";
               }
          },
          async searchShiftDebouncer(search_key) {
               this.shift_loading = true;
               this.shift_search_key = search_key || '';
               try {
                    let params = {
                         skip: 0,
                         limit: 10,
                         search_key: this.shift_search_key,
                         sort_key: "shift_name",
                         sort_value: 1
                         // company_id: this.loggedInUser.company_id
                    };
                    let response = await this.getWorkShiftList(params);
                    this.shift_name_options = response.response.workshifts;
                    this.shift_count = response.response.workshifts.length;
                    this.shift_loading = false;
               }
               catch (error) {
                    // console.log(error);
               }
          },
          async reachedEndOfShiftList(reached) {
               this.isVisible = reached;
               if (reached) {
                    if (this.scrollable == false) {
                         this.shift_loading = true;
                         let params = {
                         limit: 10,
                         search_key: this.shift_search_key,
                         // company_id: this.loggedInUser.company_id,
                         skip: this.shift_count,
                         sort_key: "shift_name",
                         sort_value: 1
                         };
                         let response = await this.getWorkShiftList(params);
                         let temp_shift_name_options = response.response.workshifts.length;;
                         if (response.response.skip == this.shift_count) {
                         if (temp_shift_name_options > 0) {
                              let tempFiles = response.response.workshifts;
                              tempFiles.forEach(el => {
                                   this.shift_name_options.push(el);
                              });
                              this.shift_count += response.response.workshifts.length;
                              this.shift_loading = false
                         } else {
                              this.scrollable = true
                              this.shift_loading = false
                         }
                         }
                         this.shift_loading = false
                    }
               }
          },
          validateDataAndTime() {
               if(this.schedule_time == 'Run once at' || this.schedule_time == 'Daily' || this.schedule_time == 'Run Once At' || this.schedule_time == 'run once at' || this.schedule_time == 'daily') {
                    this.is_report_date = false;
                    this.is_report_time = false;
                    if(this.report_date == '' || this.report_time == '') {
                         return false;
                    }
                    return true;
               } else if(this.schedule_time == 'Recurrence' || this.schedule_time == 'recurrence') {
                    this.is_report_date = false;
                    this.is_report_time = false;
                    if(this.start_date == '' || this.start_time == '' || this.end_date == '' || this.end_time == '') {
                         return false;
                    }
                    return true;
               }
          },
          async fetchDataById(id) {
               this.data_loader = true
               try {
                    let params = {
                         report_schedule_id: id
                    };
                    let response = await this.getReportScheduleById(params);
                    this.schedule_name = response.response.schedule_name;
                    this.email_ids = response.response.email_id || '';
                    this.email_ids.forEach((element, index) => {
                         this.email_ids[index] = {
                              text: element,
                              tiClasses: ['ti-valid']
                         };
                    });
                    this.description = response.response.description || '';
                    this.schedule_time = response.response.report_schedule.schedule_time.replace(/_/g, ' ');
                    if(response.response.report_schedule.shiftwise) {
                         this.shift_name = {
                              shift_name: response.response.report_schedule.shiftwise
                         }
                    }
                    // this.report_date = response.response.report_schedule.start_date_time.start_date;
                    // this.report_time = response.response.report_schedule.start_date_time.start_time ? this.convertTime24To12(response.response.report_schedule.start_date_time.start_time) : '';
                    // this.recurrence = response.response.report_schedule.recurrence ? response.response.report_schedule.recurrence.replace(/_/g, ' ') : '';
                    // this.start_date = response.response.report_schedule.start_date_time.start_date;
                    // this.start_time = response.response.report_schedule.start_date_time.start_time ? this.convertTime24To12(response.response.report_schedule.start_date_time.start_time) : '';
                    // this.end_date = response.response.report_schedule.end_date_time ? response.response.report_schedule.end_date_time.end_date : '';
                    // this.end_time = response.response.report_schedule.end_date_time ? this.convertTime24To12(response.response.report_schedule.end_date_time.end_time) : '';
                    this.data_loader = false
               }
               catch(error) {
                    this.data_loader = false
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
               }
          },
          saveCreateData() {
               // this.create_data.report_schedule.start_date_time.start_date = this.create_data.report_schedule.start_date_time.start_date.replace(/\//g, '-');
               if(this.schedule_time == 'Shiftwise' || this.schedule_time == 'shiftwise') {
                    // this.create_data.report_schedule.shiftwise
                    // this.create_data.report_schedule.end_date_time.end_date = this.create_data.report_schedule.end_date_time.end_date.replace(/\//g, '-');
                    // this.create_data.report_schedule.recurrence = this.create_data.report_schedule.recurrence.toLowerCase().replace(/\s/g, '_');
                    // this.create_data.report_schedule.end_date_time.end_time = this.create_data.report_schedule.end_date_time.end_time ? this.convertTime12to24WithoutSec(this.create_data.report_schedule.end_date_time.end_time) : '';
               } else {
                    delete this.create_data.report_schedule.shiftwise;
               }
               // this.create_data.report_schedule.start_date_time.start_time = this.create_data.report_schedule.start_date_time.start_time ? this.convertTime12to24WithoutSec(this.create_data.report_schedule.start_date_time.start_time) : '';
               this.create_data.report_schedule.schedule_time = this.create_data.report_schedule.schedule_time.toLowerCase().replace(/\s/g, '_');
               this.$validator.validateAll().then(async result => {
                    // if (result && this.validateDataAndTime()) {
                    if (result) {
                         this.saveSuccess();
                    } else {
                         this.warning_msg = "Please fill all the required fields";
                              this.$refs.warning_modal.open();
                         setTimeout(() => {
                              this.$refs.warning_modal.close();
                         }, 3000);
                         // if(this.start_date == '' || this.start_date == null || this.start_date == undefined) {
                         //      this.is_start_date = true;
                         // }
                         // if(this.end_date == '' || this.end_date == null || this.end_date == undefined) {
                         //      this.is_end_date = true;
                         // }
                         // if(this.start_time == '' || this.start_time == null || this.start_time == undefined) {
                         //      this.is_start_time = true;
                         // }
                         // if(this.end_time == '' || this.end_time == null || this.end_time == undefined) {
                         //      this.is_end_time = true;
                         // }
                         // if(this.report_date == '' || this.report_date == null || this.report_date == undefined) {
                         //      this.is_report_date = true;
                         // }
                         // if(this.report_time == '' || this.report_time == null || this.report_time == undefined) {
                         //      this.is_report_time = true;
                         // }
                    }
               });
          },
          async saveSuccess() {
               this.is_api_calling = true;
               try {
                    let response;
                    this.create_data.email_id.forEach((element, index) => {
                         this.create_data.email_id[index] = element.text;
                    });
                    if(this.mode == 'create') {
                         response = await this.createReportSchedule(this.create_data);
                    } else {
                         this.create_data.report_schedule_id = this.report_schedule_id;
                         response = await this.updateReportSchedule(this.create_data);
                    }
                    this.success_msg = response.response.success_message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                         this.$refs.success_modal.close();
                         this.hideModal();
                         this.$emit('saveSuccess')
                    }, 3000);
               }
               catch (error) {
                    this.is_api_calling = false;
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
               }
          },
          // startDateChange(data) {
          //      this.start_date = data;
          //      this.start_date_format = data;
          //      this.start_date_format = this.start_date_format.split('/')[1]+'/'+this.start_date_format.split('/')[0]+'/'+this.start_date_format.split('/')[2];
          //      this.report_date = data;
          //      this.$forceUpdate();
          // },
     },
     mounted() {
          if(this.mode == 'edit') {
               this.fetchDataById(this.report_schedule_id);
          }
     },
     watch: {
          // start_date(val) {
          //      if(val) {
          //           this.is_start_date = false;
          //           this.start_date = val;
          //           this.report_date = val;
          //           this.start_date_format = val;
          //           this.start_date_format = this.start_date_format.split('/')[1]+'/'+this.start_date_format.split('/')[0]+'/'+this.start_date_format.split('/')[2];
          //           this.report_date = val;
          //           this.$forceUpdate();
          //      }
          // },
          // end_date(val) {
          //      if(val) {
          //           this.is_end_date = false;
          //      }
          // },
          // start_time(val) {
          //      if(val) {
          //           this.is_start_time = false;
          //      }
          // },
          // end_time(val) {
          //      if(val) {
          //           this.is_end_time = false;
          //      }
          // },
          // report_date(val) {
          //      if(val) {
          //           this.is_report_date = false;
          //           this.start_date = val;
          //           this.report_date = val;
          //           this.start_date_format = val;
          //           this.start_date_format = this.start_date_format.split('/')[1]+'/'+this.start_date_format.split('/')[0]+'/'+this.start_date_format.split('/')[2];
          //           this.report_date = val;
          //           this.$forceUpdate();
          //      }
          // },
          // report_time(val) {
          //      if(val) {
          //           this.is_report_time = false;
          //      }
          // }
     },
     computed: {
          create_data() {
               return {
                    email_id: this.email_ids,
                    report_schedule: {
                         // end_date_time: {
                         //      end_date: this.end_date,
                         //      end_time: this.end_time
                         // },
                         // recurrence: this.recurrence,
                         schedule_time: this.schedule_time,
                         // start_date_time: {
                         //      start_date: this.schedule_time != 'Recurrence' ? this.report_date : this.start_date,
                         //      start_time: this.schedule_time != 'Recurrence' ? this.report_time : this.start_time
                         // }
                         shiftwise: this.shift_name.shift_name
                    },
                    description: this.description,
                    schedule_name: this.schedule_name
               }
          }
     },
     created() {
          this.searchShift = debounce(this.searchShiftDebouncer, 500)
          const dict = {
               custom: {
                    schedule_name:{
                         required:() => "Schedule Name is required"
                    },
                    schedule_time:{
                         required:() => "Schedule Time is required"
                    },
                    recurrence:{
                         required:() => "Recurrence is required"
                    },
                    shift_name:{
                         required:() => "Shift Name is required"
                    },
               }
          }
          this.$validator.localize('en', dict)
     }
}

</script>

<style scoped>
.btn-green-new{
    color: #fff !important;
    background-color: #388e3c !important;
}
.inner-line-hr{
    border: 0;
    width: 100%;
    border-top: 2px solid #a5a5a5;
}
.border{
    border:0.5px solid #0d84f2 !important;
}
.v-modal-dialog-actions-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: flex-end;
    padding: 15px;
    border-top: 0px solid transparent;
}

.v-modal-header-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: flex-start;
    padding-left: 15px;
    padding-top: 15px;
    border-bottom: 0px solid #E9ECEF;
    -webkit-border-top-left-radius: 15px;
    border-top-left-radius: 15px;
    -webkit-border-top-right-radius: 15px;
    border-top-right-radius: 15px;
    background-color: white !important;
}
.v-modal-dialog-title-new{
    margin-bottom: 0px !important;
    font-size: 20px !important;
    font-weight: 600 !important;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    color: #00448b !important;
    padding: 4px !important;
}
     .bord-rad-18px{
          border-radius: 18px !important;
     }
     .form-group, .form-check {
          will-change: unset !important;
     }
     .text-align-left{
          text-align: left !important;
     }
     .checkoutLoader{
          position: absolute !important;
     }
</style>
